import React from 'react';
import CoachesCornerComments from '../Comments/CoachesCornerComments';
import GroupIcon from '@material-ui/icons/Group';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const SprintCommentsSection = ({ sprintId, sprintName, currentUserId, defaultExpanded = false, commentCount = 0, unreadCount = 0, className = '' }) => {
  const [isExpanded, setIsExpanded] = React.useState(defaultExpanded);
  const [localCounts, setLocalCounts] = React.useState({ commentCount, unreadCount });

  const handleToggle = () => {
    setIsExpanded((v) => !v);
    if (!isExpanded && localCounts.unreadCount > 0) setLocalCounts({ ...localCounts, unreadCount: 0 });
  };

  return (
    <div className={`bg-succession-bg-primary border border-succession-border rounded-lg overflow-hidden ${className}`}>
      <button onClick={handleToggle} className="w-full px-6 py-4 flex items-center justify-between hover:bg-succession-hover-bg transition-colors">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-succession-primary-10">
            <GroupIcon className="text-succession-primary" style={{ width: 20, height: 20 }} />
          </div>
          <div className="text-left">
            <h3 className="font-semibold text-succession-text-primary">Coach's Corner - Sprint Discussion</h3>
            <p className="text-sm text-succession-text-secondary">Discuss overall sprint progress and objectives</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <ChatBubbleOutlineIcon className={localCounts.unreadCount > 0 ? 'text-succession-primary' : 'text-succession-text-secondary'} style={{ width: 20, height: 20 }} />
            <span className={localCounts.unreadCount > 0 ? 'text-succession-primary font-medium text-sm' : 'text-succession-text-secondary text-sm'}>
              {localCounts.commentCount}
            </span>
            {localCounts.unreadCount > 0 && (
              <span className="flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-succession-primary rounded-full">{localCounts.unreadCount}</span>
            )}
          </div>
          {isExpanded ? (
            <ExpandLessIcon className="text-succession-text-secondary" />
          ) : (
            <ExpandMoreIcon className="text-succession-text-secondary" />
          )}
        </div>
      </button>
      {isExpanded && (
        <div className="border-t border-succession-border p-6">
          <CoachesCornerComments itemId={sprintId} itemType="Sprint" onCommentAdded={() => setLocalCounts((c) => ({ ...c, commentCount: c.commentCount + 1 }))} />
        </div>
      )}
    </div>
  );
};

export default SprintCommentsSection;


